import React from "react";
import { Routes, Route } from "react-router-dom";
import AppAuth from "./AppAuth";
import Login from "../pages/Login/Login";
import Forgotpassword from "../pages/ForgotPassword/Forgotpassword";
import Dashboard from "../pages/Dashboard/Dashboard";
import Projects from "../pages/Projects/Projects";
import Reports from "../pages/Reports/Reports";
import Users from "../pages/Users/Users";
import Machine from "../pages/Machine/Machine";
import Attendance from "../pages/Attendance/Attendance";
import Profile from "../pages/Profile/Profile";
import ChangePassword from "../pages/ChangePassword/ChangePassword";
import MasterConfig from "../pages/MasterConfig/MasterConfig";
import EmailSent from "../pages/EmailSent/EmailSent";
import Inventory from "../pages/Inventory/Inventory";
import Bills from "../pages/Bills/Bills";

function AppRouter({ isUserLoggedIn }: { isUserLoggedIn: boolean }) {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/forgotpassword" element={<Forgotpassword />} />
      <Route path="emailsent" element={<EmailSent />} />
      <Route
        path="/dashboard"
        element={
          <React.Suspense fallback={<>...</>}>
            <AppAuth isUserLoggedIn={isUserLoggedIn}>
              <Dashboard />
            </AppAuth>
          </React.Suspense>
        }
      />
      <Route
        path="/projects"
        element={
          <React.Suspense fallback={<>...</>}>
            <AppAuth isUserLoggedIn={isUserLoggedIn}>
              <Projects />
            </AppAuth>
          </React.Suspense>
        }
      />
      <Route
        path="/bills"
        element={
          <React.Suspense fallback={<>...</>}>
            <AppAuth isUserLoggedIn={isUserLoggedIn}>
              <Bills />
            </AppAuth>
          </React.Suspense>
        }
      />
      <Route
        path="/reports"
        element={
          <React.Suspense fallback={<>...</>}>
            <AppAuth isUserLoggedIn={isUserLoggedIn}>
              <Reports />
            </AppAuth>
          </React.Suspense>
        }
      />
      <Route
        path="/users"
        element={
          <React.Suspense fallback={<>...</>}>
            <AppAuth isUserLoggedIn={isUserLoggedIn}>
              <Users />
            </AppAuth>
          </React.Suspense>
        }
      />
      <Route
        path="/users"
        element={
          <React.Suspense fallback={<>...</>}>
            <AppAuth isUserLoggedIn={isUserLoggedIn}>
              <Users />
            </AppAuth>
          </React.Suspense>
        }
      />
      <Route
        path="/machine"
        element={
          <React.Suspense fallback={<>...</>}>
            <AppAuth isUserLoggedIn={isUserLoggedIn}>
              <Machine />
            </AppAuth>
          </React.Suspense>
        }
      />
      <Route
        path="/inventory"
        element={
          <React.Suspense fallback={<>...</>}>
            <AppAuth isUserLoggedIn={isUserLoggedIn}>
              <Inventory />
            </AppAuth>
          </React.Suspense>
        }
      />
      <Route
        path="/attendance"
        element={
          <React.Suspense fallback={<>...</>}>
            <AppAuth isUserLoggedIn={isUserLoggedIn}>
              <Attendance />
            </AppAuth>
          </React.Suspense>
        }
      />
      <Route
        path="/profile"
        element={
          <React.Suspense fallback={<>...</>}>
            <AppAuth isUserLoggedIn={isUserLoggedIn}>
              <Profile />
            </AppAuth>
          </React.Suspense>
        }
      />
      <Route
        path="/change_password"
        element={
          <React.Suspense fallback={<>...</>}>
            <AppAuth isUserLoggedIn={isUserLoggedIn}>
              <ChangePassword />
            </AppAuth>
          </React.Suspense>
        }
      />
      <Route
        path="/master"
        element={
          <React.Suspense fallback={<>...</>}>
            <AppAuth isUserLoggedIn={isUserLoggedIn}>
              <MasterConfig />
            </AppAuth>
          </React.Suspense>
        }
      />
    </Routes>
  );
}

export default AppRouter;
